import { createContext, useContext } from "react";

export interface CandidateIdsContextValue {
    cId: string;
    eId: string;
    candidateId: string;
}

export const CandidateIdsContext = createContext<CandidateIdsContextValue | undefined>(undefined);

export function useCandidateIds(): CandidateIdsContextValue {
    const ctx = useContext(CandidateIdsContext);
    if (!ctx) {
        throw new Error("useCandidateIds must be used within a CandidateIdsContext.Provider");
    }
    return ctx;
}
